<div class="mb-2 sticky-banner" *ngIf="showBanner" >
  <ngb-alert [type]="notification.notificationType" [dismissible]="notification.dismissable" style="border: 1px solid">
    <div class="alert-body">
      <p [innerHTML]="currentLang === 'ro' ? notification.contentRo : notification.contentEn"></p>
    </div>
  </ngb-alert>
</div>
